import React from 'react';
import { Box, Heading, Text, CircularProgress } from '@medely/ui-kit';
import OnboardingList from 'components/onboarding/OnboardingList';
import useOnboardingSteps from 'hooks/useOnboardingSteps';
import { OnboardingVideoModal } from '@mp/components/OnboardingVideoModal';
import { useOnboardingModalTrigger } from '@mp/hooks/useOnboardingModalTrigger';
import { useOnboardingVideoConfig } from '@mp/hooks/useOnboardingVideoConfig';
import { useCurrentUser } from '@mp';

export default function Onboarding() {
  const { steps, isLoading } = useOnboardingSteps({ refetch: true });
  const { isOpen, open, close } = useOnboardingModalTrigger();
  const { videoUrl } = useOnboardingVideoConfig();
  const { proType } = useCurrentUser();
  const isCore = proType === 'irp';

  return (
    <>
      {videoUrl && proType !== 'agency' && (
        <OnboardingVideoModal visible={isOpen} onClose={close} videoUrl={videoUrl} />
      )}

      <Heading size="m" testId="onboarding-title">
        Let&apos;s get you set up
      </Heading>
      <Box mt={0.5}>
        <Text size="m" testId="onboarding-subtitle">
          {isCore
            ? 'Complete your onboarding by finishing the tasks below.'
            : "You're almost there! Complete all onboarding steps so we can review your profile and get you ready to book shifts."}
        </Text>
      </Box>

      <Box my={2}>
        {isLoading ? (
          <CircularProgress size={20} />
        ) : (
          <OnboardingList steps={steps} onLearnMoreClick={open} />
        )}
      </Box>
    </>
  );
}
